const Servicios = () => {
  return (
    <div className="card p-4 b-radius-10">
                  <h2 style={{ color: "#05294F" }}><strong>Servicios</strong></h2>
                  <hr />
                  <div className="contenido">
                    <div>
                      <p>
                        Acompañamos al paciente desde el inicio hasta el final de su recorrido.
                      </p>
                      <p>
                        <img
                          className="img-fluid"
                          alt="imagen"
                          src="https://sitioinstituionalqa.blob.core.windows.net/strapi-qa/strapi-qa/assets/Desde_su_primera_solicitud_Coordinamos_sus_citas_y_su_admision_1_68a946c24c.png"
                        />
                      </p>
                      <p>Ofrecemos:</p>
                      <p>
                        <strong>Atención Prioritaria y Seguimiento Personalizado</strong>:
                        {" "}
                        Los asistentes de Privilege HB se encargarán de gestionar de manera prioritaria todas sus solicitudes, incluyendo reserva de habitación, y realizando un seguimiento diario del caso. Cada gestión será registrada en detalle actualizando la información diariamente.
                      </p>
                      <p>
                        <strong>Gestión de Presupuestos</strong>:{" "}
                        Todas las solicitudes de presupuesto serán gestionadas de manera personalizada, y serán respondidas dentro de las 24 hs de ser solicitadas.
                      </p>
                      <p>
                        <strong>Facilidades de Pago</strong>:{" "}
                        Se aceptan pagos con tarjeta desde la oficina de Privilege HB, transferencias bancarias, Mercado Pago o pagos con tarjeta de crédito/débito para teleconsultas con pacientes internacionales.
                      </p>
                    </div>
                  </div>
                </div>
  );
};

export default Servicios;